module.exports = __webpack_public_path__ + "img/icon-contrast-yellow.5cd8469f.svg";